import CustomError from '@/script/Error.mjs'

export class ValidationError extends CustomError {
    constructor(message, target) {
        super(message)
        this.target = target
    }
}

ValidationError.prototype.name = 'ValidationError'
